import React, { useEffect, useState } from 'react'
import { BASE_URL } from './Config/Config';
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';


function Faqarea() {
 const [data , setdata ] = useState([]);
 const [showAns, setShowAns] = useState(false);
 const [galleryData, setGalleryData] = useState([]);

  const API = `${BASE_URL}/coursefaq/`;

 useEffect(() => {
    const fetchGallery = async () => {
      try {
        const response = await fetch(`${BASE_URL}/GalleryMaster/`);
        const result = await response.json();
        setGalleryData(result.data || []);
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    fetchGallery();
  }, []);
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next" onClick={onClick}>
    <i className="fa-regular fa-arrow-right"  />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev" onClick={onClick}>
    <i className="fa-regular fa-arrow-right" style={{ transform: 'rotate(180deg)' }} />

 </div>
);


   const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
     nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  };

const coursefaq =  async(URL)=>{
   try {
     const response = await fetch(URL,{
          method:'GET',
          headers:{
            'Content-Type': 'application/json',
          },
          credentials: 'include',
     });
     if(!response.ok){
      throw new Error('Failed to fetch data');
     }
     else{
      const resData = await response.json();
          setdata(resData.data);
        }
        console.log(data);          


   } catch (error) {
    console.error('Failed to fetch data', error);
   }
}
  useEffect(()=>{
    coursefaq(API);
  },[]);

  return (
  <>
   
<div className="overflow-hidden space">
  <div className="container">
    <div className="row">


      <div className="col-xl-6 align-self-end text-xl-end order-xl-2">
       <div className="faq-slider">
  <Slider {...settings}>
    {galleryData.map((item, index) => (
      <div key={index} className="faq-img text-center">
        <img
          src={`${BASE_URL}${item.Gallery_Img}`}
          alt={item.GalleryName}
        />
      </div>
    ))}
  </Slider>
</div>

      </div>


      <div className="col-xl-6 order-xl-1">
        <div className="me-xl-5">
          <div className="title-area">
            <span className="sub-title"><i className="fal fa-book" /> Explore Auratech Academy</span>
            <h2 className="sec-title">Frequently Asked Question?</h2>
          </div>

          <div className="accordion-area accordion" id="faqAccordion">
      {data.map((curfaq, index) => {
        const isExpanded = showAns === index; // Check if this item is expanded
        const uniqueId = `collapse-${index}`;
        const headingId = `heading-${index}`;

        return (
          <div className="accordion-card" key={index}>
            <div className="accordion-header"id={headingId}>
              <button
                className={`accordion-button ${!isExpanded ? 'collapsed' : ''}`}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#${uniqueId}`}
                aria-expanded={isExpanded}
                aria-controls={uniqueId}
                onClick={() => setShowAns(isExpanded ? null : index)} 
              >
                {curfaq.courseFaq_Que}
                 {/* <span className="ms-auto">
    {isExpanded ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>}
  </span> */}
              </button>
            </div>

            <div
              id={uniqueId}
              className={`accordion-collapse collapse ${isExpanded ? 'show' : ''}`}
              aria-labelledby={headingId}
              data-bs-parent="#faqAccordion"
            >
              <div className="accordion-body">
                <p className="faq-text">{curfaq.courseFaq_Ans}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>

        </div>
      </div>
    </div>
  </div>
</div>

  </>
  )
}

export default Faqarea